import { createFileRoute, redirect } from "@tanstack/react-router";

/** A shareable address for one call; it opens in the Calls list beside the others. */
export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/calls/$callId",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/app/$organizationSlug/calls",
			params: { organizationSlug: params.organizationSlug },
			search: { id: params.callId },
		});
	},
});
